import { Typography, Box } from "@mui/material"
import { withTheme } from "@emotion/react"
import JobCard from "./Job/JobCard";
import Grid from '@mui/material/Unstable_Grid2';
import PyscIcon from '../../../assets/pychologyIcon.svg'
import Doctor from '../../../assets/doctorIcon.svg'
import Cardiogloist from '../../../assets/cardiologistIcon.svg'
import Dermatologist from '../../../assets/dermatologistIcon.svg'
import SpecialDoctor from '../../../assets/specialistDoctorIcon.svg'
import Nurse from '../../../assets/nurseIcon.svg'
import Banner from "./Job/Banner";

const Jobs = (props) => {

  return (<Box sx={{ width: '100%', display: 'contents' }}>
    <Grid direction='row' container rowSpacing="48px" columnSpacing={{ xs: "8px", sm: "16px", md: "24px" }}>
      {
        props.jobs.map((job, index) => (
          <Grid key={index} xs={12} sm={6} md={4}>
            <JobCard jobId={index} text={job.heading} image={job.image} />
          </Grid>
        ))
      }
    </Grid>
  </Box>
  )
}

const HeaderText = (props) => {

  return (
    <Box gap="24px" mt="120px" mb="100px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" >
      <Typography sx={props.theme.typography.headBig} >Explore our openings</Typography>
      <Typography sx={props.theme.typography.subtitle1} >
        We are on the lookout for passionate and dedicated individuals to join us.
        We value dedication, loyalty and clear communication.
      </Typography>
    </Box>
  )

}


const JoinUs = (props) => {

  const jobs = [
    { heading: 'Psychologist', image: PyscIcon },
    { heading: 'Nurse', image: Nurse },
    { heading: 'General Doctor', image: Doctor },
    { heading: 'Cardiologist', image: Cardiogloist },
    { heading: 'Dermatologist', image: Dermatologist },
    { heading: 'Specialist Doctor', image: SpecialDoctor }
  ]

  const theme = props.theme

  return (

    <>
      <HeaderText theme={theme} />
      <Jobs jobs={jobs} />
      <Banner />
    </>

  )
}


export default withTheme(JoinUs);